import type { BacklogConfig as BacklogConfigContract } from "./contracts/BacklogConfig";
import type { BacklogApiRequestOption } from "./contracts/api/BacklogApiRequestOption";

export class BacklogConfig implements BacklogConfigContract {
	constructor(
		private options:
			| {
					host: string | URL;
					apiKey: string;
					defaultRequestOptions?: BacklogApiRequestOption;
			  }
			| {
					host: string | URL;
					accessToken: string;
					defaultRequestOptions?: BacklogApiRequestOption;
			  },
	) {}

	getBaseUrl(): URL {
		if (this.options.host instanceof URL) {
			return this.options.host;
		}
		return new URL(`https://${this.options.host}`);
	}

	getApiKey(): string | undefined {
		return "apiKey" in this.options ? this.options.apiKey : undefined;
	}

	getAccessToken(): string | undefined {
		return "accessToken" in this.options ? this.options.accessToken : undefined;
	}

	getDefaultRequestOptions(): BacklogApiRequestOption | undefined {
		return this.options.defaultRequestOptions;
	}
}
